module.exports = __webpack_public_path__ + "img/commute-to-university.8e51280c.svg";